'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosHelp = function IoIosHelp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m0.3 24.8c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.4-1.3-1.4-1.4 0.7-1.4 1.4 0.7 1.3 1.4 1.3z m2.6-9c1.2-1.1 2-2.3 2-4 0-2.6-2.1-4.2-4.6-4.2-3.4 0-5.4 1.6-5.4 4.8h1.5c0-2.3 1.3-3.5 3.8-3.5 1.8 0 3.3 1.1 3.3 3 0 1.2-0.7 2.3-1.5 3-1.8 1.7-2.3 2.9-2.4 5h1.5c0.1-2 0-2.4 1.8-4.1z' })
        )
    );
};

exports.default = IoIosHelp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-help.js
// module id = 2664
// module chunks = 168707334958949